module.exports = __webpack_public_path__ + "static/persist-nashville-96ba821cc54040c15e7ec48b025603fd.jpg";